module.exports = __webpack_public_path__ + "img/calendar.92fa2f2.svg?v=1750235198135";